/* eslint no-console: ["error", { allow: ["warn", "error"] }] */

window.ANALYTICS = window.ANALYTICS || { debug: false };
window.ANALYTICS.mixpanel = window.ANALYTICS.mixpanel || {};
window.ANALYTICS.segment = window.ANALYTICS.segment || {};

if (typeof window.mixpanel !== 'undefined') {
    window.ANALYTICS.mixpanel.track = function mixpanelTrack(...args) {
        if (window.ANALYTICS.debug === true) {
            console.warn(...args);
        }

        window.mixpanel.track(...args);
    };
} else {
    window.ANALYTICS.mixpanel.track = function mixpanelTrack(...args) {
        if (window.ANALYTICS.debug === true) {
            console.warn('mixpanel is not defined');
            console.warn(...args);
        }
    };
}

if (typeof window.analytics !== 'undefined') {
    window.ANALYTICS.segment.track = function segmentTrack(...args) {
        if (window.ANALYTICS.debug === true) {
            console.warn(...args);
        }

        window.analytics.track(...args);
    };
} else {
    window.ANALYTICS.segment.track = function segmentTrack(...args) {
        if (window.ANALYTICS.debug === true) {
            console.warn('segment is not defined');
            console.warn(...args);
        }
    };
}

const captureGetStarted = function captureGetStarted(age, amount, funds) {
    window.ANALYTICS.mixpanel.track('Clicked: Get Started');
    window.ANALYTICS.segment.track('Get Started', {
        age,
        amount,
        funds,
    });
};

const analytics = {
    captureGetStarted,
};

export default analytics;




// WEBPACK FOOTER //
// ./app/scripts/components/analytics.js